import React, { Component } from "react";
import { Grid, Col, Row , Panel, Button, Table} from 'react-bootstrap';
import { UserService } from "../Services/UserService";
import ReactChartkick, { PieChart, LineChart, ColumnChart} from 'react-chartkick';
import Chart from 'chart.js';
import { ReportService } from "../Services/ReportService";
import DatePicker from 'react-datepicker';
import moment from 'moment';
import { Constants } from "../Constants";
import { toInt, format_date_only_new, formatNumber, getTimeInIST } from "../Utils";
import { ProductService } from "../Services/ProductService";
import Paper from '@material-ui/core/Paper';
import { withStyles, LinearProgress, Fade } from "@material-ui/core";
import AutoCompleteSelection from "../components/AutoCompleteSelection_v2";

ReactChartkick.addAdapter(Chart);

const styles = theme => ({
    root: {
      width: '100%',
    },
    heading: {
      fontSize: theme.typography.pxToRem(15),
      fontWeight: theme.typography.fontWeightRegular,
    },
    margin: {
        margin: theme.spacing(1),
    },
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
    },
    paper: {
        position: 'absolute',
        width: theme.spacing(50),
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        padding: theme.spacing(4),
        outline: 'none',
    },
  });

class StoreSummary extends Component {

    constructor(props) {
      super(props);

      props.setTitle('Store Summary');

      this.state = {
        data: [],
        selectedStore: {id: "-1"},
        trend_data: null,
        trend_sales_data: null,
        performance_data: null,
        product_stats_rows: null,
        product_stats_returned: [],
        product_stats_replaced: [],
        product_stats_sales: [],
        numItemsPerPage: 10000,
        currentPageNumber: 0,
        totalItems: 1,
        totalPages: 0,
        startDate: moment().subtract(365, "days"),
        endDate: moment(),
        master_products: [],
        sales: [],
        loading1: false,
        loading2: false,
        loading3: false,
        loading4: false,
        loading5: false,
        store_names: [],
      }
      this.handleChange = this.handleChange.bind(this);
      this.handleChangeStart = this.handleChangeStart.bind(this);
      this.handleChangeEnd = this.handleChangeEnd.bind(this);
      this.fetchStats = this.fetchStats.bind(this);
    }
 
    componentWillMount(){
        this.fetchData(0, this.state.numItemsPerPage);
    }

    fetchData(start, numberItems){
        this.props.isLoading(true);
        ProductService.getProductList()
        .then((data) => {
            this.setState({master_products: data.products});
            UserService.getStoreList(start, numberItems, '', '', '', '0,1,2')
            .then((data) => {
                console.log(data);
                let store_names = data.users.map((w) => (
                    {
                        id: w.id,
                        value: w.id, 
                        label: `${w.store_name}`
                    }
                )); 
                this.setState({data: data.users, store_names});
                this.props.isLoading(false);
            })
            .catch(error => {
                console.log(error);
                this.props.isLoading(false);
            });
        })
        .catch(error => {
            console.log(error);
        });
    }

    fetchStats(e){
        let store = this.state.selectedStore;
        if(store){
            this.setState({loading1: true, loading2: true, loading3: true, loading4: true, loading5: true});
            this.fetchStoreSalesStats(store);
            this.fetchStoreSalesAmount(store);
            this.fetchPerformance(store);
            this.fetchProductSalesStats(store);
            // this.fetchProductStats(store);
        } 
    }

    handleChange(store) {
        if(store){
            this.setState({loading1: true, loading2: true, loading3: true, loading4: true, loading5: true});
            this.fetchStoreSalesStats(store);
            this.fetchStoreSalesAmount(store);
            this.fetchPerformance(store);
            this.fetchProductSalesStats(store);
        } else {
            this.setState({performance_data: null, trend_sales_data: null, trend_data: null, product_stats_rows: null, product_stats_returned: null, product_stats_replaced: null, product_stats_sales: null})
        }
    }

    handleChangeStart(date){
        this.setState({
            startDate: date
        });
    }

    handleChangeEnd(date){
        this.setState({
            endDate: date
        });
    }


    fetchStoreSalesStats(store) {
        ReportService.getReportSalesStatsForStore(this.state.startDate, this.state.endDate, store)
            .then((data) => {
                console.log(data);
                let dataIn = [];
                let d = data.report.sort(function (a, b) {
                    return parseInt(b.total_qty, 10) - parseInt(a.total_qty, 10);
                });
                d.forEach(element => {
                    dataIn.push([element.product_name, element.total_qty]);
                });
                this.setState({ loading1: false, trend_data: dataIn, sales: data.report }, () => this.fetchProductStats(store));
                // this.props.isLoading(false);
            })
            .catch(error => {
                console.log(error);
                this.setState({ loading1: false});
                this.props.isLoading(false);
            });
    }

    fetchStoreSalesAmount(store) {
        ReportService.getReportSalesForStore(this.state.startDate, this.state.endDate, store)
            .then((data) => {
                console.log(data);
                let dataIn = [];
                data.report.forEach(element => {
                    dataIn.push([ moment(element.schedule_date).format(format_date_only_new), parseFloat(element.total_amount)]);
                });
                this.setState({ loading4: false, trend_sales_data: dataIn });
                // this.props.isLoading(false);
            })
            .catch(error => {
                console.log(error);
                this.setState({ loading4: false});
                this.props.isLoading(false);
            });
    }

    fetchPerformance(store){
        ReportService.getReportStoresB2WForStore(Constants.STORE, this.state.startDate, this.state.endDate, store)
        .then((data) => {
            console.log(data);
            this.setState({loading3: false, performance_data: data.report && data.report[0].total_amount})
            this.props.isLoading(false);
        })
        .catch(error => {
            console.log(error);
            this.props.isLoading(false);
            this.setState({ loading3: false});
        });
    }

    fetchProductStats(store){
        ReportService.getReportStoresProductStatsForStore(Constants.STORE, this.state.startDate, this.state.endDate, false, store)
        .then((data) => {
            console.log(data);
            let product_stats_rows = [];
            data.report.forEach(element => {
                let p = this.state.master_products.filter((p1) => {return p1.id === element.product_id})[0];
                if(p){
                    let sale = this.state.sales.filter(pr => pr.product_name === p.name);
                    product_stats_rows.push(<ReportDetails key={element.product_id} report={element} product={p} sales={sale.length > 0? sale[0].total_qty : 0 }/>);
                }
            });
            this.setState({loading2: false, product_stats_rows: product_stats_rows});
            this.props.isLoading(false);
        })
        .catch(error => {
            console.log(error);
            this.setState({ loading2: false});
            this.props.isLoading(false);
        });

        ReportService.getReportStoresProductStatsForStore(Constants.STORE, this.state.startDate, this.state.endDate, true, store)
        .then((data) => {
            console.log(data);
            let product_stats_returned = [], p = new Map(), product_stats_replaced = [], r = new Map();
            data.report.forEach(element => {
                let a = {}, b = {};
                if(p.has(element.product_id)){
                    a = p.get(element.product_id);
                    b = r.get(element.product_id);
                }
                a[element.delivery_date] = toInt(element.returned_count);
                b[element.delivery_date] = toInt(element.replaced_count);
                p.set(element.product_id, a);
                r.set(element.product_id, b);
            });
            p.forEach((value, key, map) => {
                let p = this.state.master_products.filter((p1) => {return p1.id === key})[0];
                product_stats_returned.push({"name" : p.name, "data": value});
            });
            r.forEach((value, key, map) => {
                let p = this.state.master_products.filter((p1) => {return p1.id === key})[0];
                product_stats_replaced.push({"name" : p.name, "data": value});
            });
            this.setState({product_stats_returned: product_stats_returned, product_stats_replaced: product_stats_replaced});
            this.props.isLoading(false);
        })
        .catch(error => {
            console.log(error);
            this.props.isLoading(false);
        });
    }

    fetchProductSalesStats(store){
    
        ReportService.getReportStoresProductSalesStatsForStore(Constants.STORE, this.state.startDate, this.state.endDate, true, store)
        .then((data) => {
            console.log(data);
            let product_stats_sales = [], p = new Map();
            data.report.forEach(element => {
                let a = {};
                if(p.has(element.product_id)){
                    a = p.get(element.product_id);
                }
                a[element.delivery_date] = toInt(element.delivered_count);
                p.set(element.product_id, a);
            });
            p.forEach((value, key, map) => {
                let p = this.state.master_products.filter((p1) => {return p1.id === key})[0];
                product_stats_sales.push({"name" : p.name, "data": value});
            });
            this.setState({loading5: false, product_stats_sales: product_stats_sales});
            this.props.isLoading(false);
        })
        .catch(error => {
            console.log(error);
            this.props.isLoading(false);
            this.setState({loading5: false});
        });
    }

    render() {
        let store = this.state.data.filter((s) => s.id === this.state.selectedStore)[0];
        let {loading1, loading2, loading3} = this.state;
        return (
            <div className="Home">
                <Paper style={{width: "100%", marginTop: 50, paddingLeft: 8, paddingRight: 5}}>
                    <div style={{marginLeft: '10px', marginRight: 10, paddingTop: 20}}>
                        <Fade
                            in={loading1 || loading2 || loading3}
                            style={{
                                transitionDelay: loading1 || loading2 || loading3 ? '800ms' : '0ms',
                                marginBottom: 10
                            }}
                            unmountOnExit>
                            <LinearProgress color="secondary"/>
                        </Fade>
                        <AutoCompleteSelection 
                            placeHolder="Select Store"
                            isMulti={false}
                            onChange={(e) => {
                                this.setState({selectedStore: e.value}, () => {
                                    this.handleChange(e.value);
                                });
                            }}
                            value={this.state.store_names.filter((store) => store.id === this.state.selectedStore.id)}
                            required={true}
                            options={this.state.store_names}/>
                    </div>
                    <div className="">
                        <Grid>
                            { store && 
                                <Row>
                                    <Col xs={12} md={12} style={{textAlign: "left", maxWidth: '99%'}}>
                                        <Panel bsStyle="info">
                                            <Panel.Heading>
                                                <Panel.Title componentClass="h3">
                                                    Store Details
                                                </Panel.Title>
                                            </Panel.Heading>
                                            <Panel.Body style={{backgroundColor: "white"}}> 
                                                <Grid style={{textAlign: "left"}}>
                                                    <Row>
                                                        <Col xs={4} md={4}><b>Store</b></Col>
                                                        <Col xs={4} md={4}>{store && store.store_name}</Col>
                                                    </Row>
                                                    <Row>
                                                        <Col xs={4} md={4}><b>Manager Name</b></Col>
                                                        <Col xs={4} md={4}>{store && store.name}</Col>
                                                    </Row>
                                                    <Row>
                                                        <Col xs={4} md={4}><b>Email</b></Col>
                                                        <Col xs={4} md={4}>{store && store.email}</Col>
                                                    </Row>
                                                    <Row>
                                                        <Col xs={4} md={4}><b>Contact No</b></Col>
                                                        <Col xs={4} md={4}>{store && store.mobile_no}</Col>
                                                    </Row>
                                                    <Row>
                                                        <Col xs={4} md={4}><b>Address</b></Col>
                                                        <Col xs={4} md={4}>{store && store.flat}</Col>
                                                    </Row>
                                                    <Row>
                                                        <Col xs={4} md={4}><b>GST No</b></Col>
                                                        <Col xs={4} md={4}>{store && store.gst_no}</Col>
                                                    </Row>
                                                </Grid>
                                            </Panel.Body>
                                        </Panel>
                                    </Col>
                                </Row>
                            }
                            { store && 
                                <Row>
                                    <Col className="sales-stats">
                                        <div className="centerwrapper">
                                            <div className = "squareLabel marginRight">From</div>
                                            <div className = "square">
                                                <DatePicker
                                                    selected={this.state.startDate}
                                                    selectsStart
                                                    dateFormat='DD/MM/YYYY'
                                                    startDate={this.state.startDate}
                                                    endDate={this.state.endDate}
                                                    onChange={this.handleChangeStart} />
                                            </div>
                                            <div className = "squareLabel">To</div>
                                            <div className = "square">
                                                <DatePicker
                                                    selected={this.state.endDate}
                                                    selectsEnd
                                                    dateFormat='DD/MM/YYYY'
                                                    startDate={this.state.startDate}
                                                    endDate={this.state.endDate}
                                                    onChange={this.handleChangeEnd}
                                                />
                                            </div>
                                            <div className = "square">
                                                <Button onClick={(e) => { this.fetchStats(e)}}>SEARCH</Button>
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                            }
                            { this.state.performance_data && 
                                <Row>
                                    <Col xs={12} md={12} style={{textAlign: "left", maxWidth: '99%'}}>
                                        <Panel bsStyle="info">
                                            <Panel.Heading>
                                                <Panel.Title componentClass="h3">
                                                    Performance
                                                </Panel.Title>
                                            </Panel.Heading>
                                            <Panel.Body style={{backgroundColor: "white"}}> 
                                                <Grid style={{textAlign: "left"}}>
                                                    <Row>
                                                        <Col xs={3} md={2}><b>Total Sales</b></Col>
                                                        <Col xs={3} md={2}>{formatNumber(this.state.performance_data)}</Col>
                                                        <Col xs={3} md={2}><b>Total Pending Amount</b></Col>
                                                        <Col xs={3} md={2} style={{color: store.pending_amount > 0 ? "red" : "blue" }}>{formatNumber(store.pending_amount)}</Col>
                                                        <Col xs={3} md={2}><b>Overdue Amount</b></Col>
                                                        <Col xs={3} md={2} style={{color: store.overdue_amount > 0 ? "red" : "blue" }}>{formatNumber(store.overdue_amount)}</Col>
                                                        <Col xs={3} md={2}><b>Ledger Last synced on</b></Col>
                                                        <Col xs={3} md={2}>{store.last_ledger_date ? getTimeInIST(store.last_ledger_date).format(format_date_only_new) : "-"}</Col>
                                                    </Row>
                                                </Grid>
                                                <div style={{maxHeight: "100%"}}>
                                                    <ColumnChart data={this.state.trend_sales_data}/>
                                                </div>
                                            </Panel.Body>
                                        </Panel>
                                    </Col>
                                </Row>
                            }
                            { this.state.trend_data && 
                                <Row>
                                    <Col xs={12} md={12} style={{textAlign: "left", maxWidth: '99%'}}>
                                        <Panel bsStyle="info">
                                            <Panel.Heading>
                                                <Panel.Title componentClass="h3">
                                                    Store Product Trends
                                                </Panel.Title>
                                            </Panel.Heading>
                                            <Panel.Body style={{backgroundColor: "white", minHeight: "300px"}}> 
                                                <div style={{maxHeight: "100%"}}>
                                                    <PieChart donut={true} data={this.state.trend_data}/>
                                                </div>
                                                <div>
                                                    <LineChart data={this.state.product_stats_sales}/> 
                                                </div>
                                            </Panel.Body>
                                        </Panel>
                                    </Col>
                                </Row>
                            }
                            {
                                this.state.product_stats_rows && 
                                <Row>
                                    <Col xs={12} md={12} style={{textAlign: "left", maxWidth: '99%'}}>
                                        <Panel bsStyle="info">
                                            <Panel.Heading>
                                                <Panel.Title componentClass="h3">
                                                    Products Return Trend
                                                </Panel.Title>
                                            </Panel.Heading>
                                            <Panel.Body style={{backgroundColor: "white", minHeight: "100px"}}>
                                                <div style={{width: "100%"}}>
                                                    {/* <div style={{float: "right", width: "50%"}}>
                                                        <section>Replacements</section>
                                                        <LineChart data={this.state.product_stats_replaced}/> 
                                                    </div> */}
                                                    <div>
                                                        <section>Returns</section>
                                                        <LineChart data={this.state.product_stats_returned}/> 
                                                    </div>
                                                </div>
                                                <Table striped condensed hover responsive>
                                                    <thead>
                                                        <tr>
                                                            <th>Product</th>
                                                            <th>Delivered Count</th>
                                                            <th>Avg Returns</th>
                                                            <th>Min Returns</th>
                                                            <th>Max Returns</th>
                                                            {/* <th>Avg Replacements</th>
                                                            <th>Min Replacements</th>
                                                            <th>Max Replacements</th> */}
                                                        </tr>
                                                    </thead>
                                                    <tbody style={{textAlign: "left"}}>
                                                        {this.state.product_stats_rows}
                                                    </tbody>
                                                </Table>
                                            </Panel.Body>
                                        </Panel>
                                    </Col>
                                </Row>
                            }
                        </Grid>
                    </div>
                </Paper>
            </div>
        );
    }

}

class ReportDetails extends Component {

    render(){
        const report = this.props.report;
        report.product_name = this.props.product.name;
        const sales = this.props.sales;
        return (
            <tr>
                <td>{report.product_name}</td>
                <td>{sales}</td>
                <td>{report.avg_returned}</td>
                <td>{report.min_returned}</td>
                <td>{report.max_returned}</td>
                {/* <td>{report.avg_replaced}</td>
                <td>{report.min_replaced}</td>
                <td>{report.max_replaced}</td> */}
            </tr>
        );
    }
}

export default withStyles(styles)(StoreSummary);